module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiPjxwYXRoIGZpbGw9IiM4ZmYiIGQ9Ik0wIDgyMi4yMTRoNzM3LjI0TDEwMjQgMjAxLjc4NkgyODYuNzZ6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ../static/img/svg-icons/bandcamp.svg
// module id = 409
// module chunks = 0